import { Component, computed, inject, Input } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { NgClass, NgIf } from '@angular/common';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { SharedService } from 'src/app/services/shared.service';
import { ComponentItem } from 'src/app/types/component';
import { FilterConfig } from '../../types/filter-config';
import { FilterControlsComponent } from '../filter-controls/filter-controls.component';

/**
 * Custom filter button component
 * show {@link FilterControlsComponent} in sidepanel when clicked
 * requires {@link FilterConfig} input
 * to configure which filter options should available
 *
 * @class FilterButtonComponent
 * @typedef {FilterButtonComponent}
 */
@Component({
    selector: 'riege-filter-button',
    imports: [MatButtonModule, MatIconModule, MatBadgeModule, NgIf, NgClass],
    templateUrl: './filter-button.component.html',
    styleUrl: './filter-button.component.scss',
    standalone: true
})
export class FilterButtonComponent {
    /** required filter config input */
    @Input({ required: true }) filterConfig?: FilterConfig;
    /** counter input to show how many filter had been applied  */
    @Input() count = 0;

    /** computed value, if viewport matches mobile device */
    isMobile = computed(() => this.#breakpointService.currentScreenSize() === 'XSmall');
    isTablet = computed(() => this.#breakpointService.currentScreenSize() === 'Small');

    #breakpointService = inject(BreakpointService);
    #sharedService = inject(SharedService);

    /** main helper function to show filter controls in sidepanel */
    showFilter() {
        const component: ComponentItem = {
            type: FilterControlsComponent,
            data: this.filterConfig
        };
        this.#sharedService.handleFilterSidepanel(component);
    }
}
